import { render, staticRenderFns } from "./Inquire.vue?vue&type=template&id=6d4bab5a&scoped=true&"
var script = {}
import style0 from "./Inquire.vue?vue&type=style&index=0&id=6d4bab5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4bab5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d4bab5a')) {
      api.createRecord('6d4bab5a', component.options)
    } else {
      api.reload('6d4bab5a', component.options)
    }
    module.hot.accept("./Inquire.vue?vue&type=template&id=6d4bab5a&scoped=true&", function () {
      api.rerender('6d4bab5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/Snippets/Inquire.vue"
export default component.exports